// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from "react-native";
import colors from "../../config/colors";
import fonts from "../../config/fonts";

const NumberSelectorStyle = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: colors.green,
    borderRadius: 10,
    width: "80%",
    marginHorizontal: "10%",
  },
  button: {
    borderRadius: 10,
    padding: 8, 
  },
  text: {
    color: colors.white,
    fontSize: 24, // Increased font size
    fontWeight: "bold",
    fontFamily: fonts.regular,
  },
  editableLabel: {
    fontWeight: "bold",
    color: "white",
    width: "40%", // Adjusted width to match the new layout
    textAlign: "center",
    fontSize: 24, // Increased font size for input
    backgroundColor: colors.darkGreen,
    paddingVertical: 5, // Added padding to make it easier to edit
  },
  label: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
});

export default NumberSelectorStyle;
